import 'css-chunksrc/client/scenes/projectPopup/projectPortfoliosList/styles.scss';export default {
  "projectPortfoliosList": "_projectPortfoliosList_ufz4y_1",
  "item": "_item_ufz4y_10",
  "icon": "_icon_ufz4y_14",
  "input": "_input_ufz4y_19",
  "list": "_list_ufz4y_24"
};